import { h } from "omi";

import { IconProps } from "@/wc/components";

export function MedalOneIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none">
      <path
        d="M6.67634 10.2792L3.29434 4.22722C2.90546 3.53134 2.71102 3.1834 2.74379 2.89852C2.77238 2.64997 2.90439 2.42498 3.10741 2.27878C3.3401 2.11121 3.73869 2.11121 4.53586 2.11121H6.52237C6.81863 2.11121 6.96676 2.11121 7.09963 2.15399C7.2172 2.19185 7.32559 2.2538 7.41789 2.33588C7.52219 2.42865 7.59738 2.55628 7.74776 2.81154L11.0007 8.33343L14.2537 2.81154C14.4041 2.55628 14.4793 2.42865 14.5836 2.33588C14.6759 2.2538 14.7843 2.19185 14.9019 2.15399C15.0347 2.11121 15.1829 2.11121 15.4791 2.11121H17.4656C18.2628 2.11121 18.6614 2.11121 18.8941 2.27878C19.0971 2.42498 19.2291 2.64997 19.2577 2.89852C19.2905 3.1834 19.096 3.53134 18.7072 4.22722L15.3252 10.2792M9.66741 12.7779L11.0007 11.889V16.3334M9.88963 16.3334H12.1119M15.0863 10.0257C17.3426 12.2821 17.3426 15.9403 15.0863 18.1967C12.8299 20.4531 9.17161 20.4531 6.91524 18.1967C4.65888 15.9404 4.65888 12.2821 6.91524 10.0257C9.17159 7.76934 12.8299 7.76934 15.0863 10.0257Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
